<div class="ts-button-toggle" [ngClass]="'ts-button-toggle--' + variant()">
  @for (option of options(); track option.value) {
    <button
      type="button"
      class="ts-button-toggle__option"
      [ngClass]="{ 'ts-button-toggle__option--selected': isSelected(option) }"
      [disabled]="isDisabled() || !!option.disabled"
      [attr.aria-pressed]="isSelected(option)"
      (click)="select(option)"
    >
      @if (option.icon) {
        <ts-icon [icon]="option.icon" [color]="isSelected(option) ? 'white' : 'gray'" />
      }
      <span class="leading-3">{{ option.label }}</span>
    </button>
  }
</div>
